import React, { Component } from "react";
import PropTypes from "prop-types";
import IconButton from "material-ui/IconButton";
import ActionSave from "material-ui/svg-icons/content/save";
import ActionCopy from "material-ui/svg-icons/content/content-copy";
import ActionPaste from "material-ui/svg-icons/content/content-paste";
import Paper from "material-ui/Paper";
import { Card, CardHeader, CardText } from "material-ui/Card";
import { RadioButton, RadioButtonGroup } from "material-ui/RadioButton";
import {
  BlockCounter,
  Counter,
  BackgroundContent,
  ItemBackgroundContent
} from "./components";
import { DivHeaderActions, DivTitle } from "./styled";
import { assignIn } from "lodash";

const bgPropertiesDefault = {
  size: "cover",
  position: "center center",
  repeat: "no-repeat"
};

const defaultItemProps = {
  backgroundColorParent: "rgba(255,255,255,0)",
  width: {
    type: "%",
    contentWidth: 100
  },
  alignment: {
    vertical: "center",
    horizontal: "center"
  }
};

class Row extends Component {
  constructor(props) {
    super(props);
    const {
      backgroundColor,
      padding,
      width,
      backgroundImage,
      isBackgroundImage,
      align,
      bgProps
    } = props.data.values;
    const bi = backgroundImage ? backgroundImage : { url: "", urlMobile: "" };
    const alignContent = align ? align : "center";
    const isBGI = isBackgroundImage ? isBackgroundImage : false;
    const bgProperties = bgProps ? bgProps : bgPropertiesDefault;
    this.state = {
      content: props.data.content,
      expanded: true,
      expandedContent: false,
      expandedContent0: false,
      expandedContent1: false,
      expandedContent2: false,
      expandedContent3: false,
      backgroundColor: backgroundColor,
      containerPadding: padding,
      contentWidth: width.contentWidth,
      type: width.type,
      maxValueWidth: width.type === "px" ? 0 : 100,
      interval: width.type === "px" ? 20 : 1,
      backgroundImage: bi,
      align: alignContent,
      isBackgroundImage: isBGI,
      bgProps: bgProperties
    };
    this.onClickPaste = this.onClickPaste.bind(this);
  }
  handleExpandChange = expanded => {
    this.setState({ expanded: expanded });
  };
  handleExpandChangeContent = expanded => {
    this.setState({ expandedContent: expanded });
  };
  handleExpandChangeContentColumn = (expanded, index) => {
    switch (index) {
      case 0:
        this.setState({ expandedContent0: expanded });
        break;
      case 1:
        this.setState({ expandedContent1: expanded });
        break;
      case 2:
        this.setState({ expandedContent2: expanded });
        break;
      case 3:
        this.setState({ expandedContent3: expanded });
        break;
      default:
        break;
    }
  };
  getExpand = index => {
    const dataEpanded = this.state;
    return dataEpanded[`expandedContent${index}`];
  };
  onClickCopy = () => {
    let newData = this.props.data;
    let width = {
      type: this.state.type,
      contentWidth: this.state.contentWidth
    };
    newData.values.backgroundColor = this.state.backgroundColor;
    newData.values.padding = this.state.containerPadding;
    newData.values.align = this.state.align;
    newData.values.backgroundImage = this.state.backgroundImage;
    newData.values.isBackgroundImage = this.state.isBackgroundImage;
    newData.values.bgProps = this.state.bgProps;
    newData.values.width = width;
    newData.content = this.state.content;
    localStorage.setItem("Row", JSON.stringify(newData));
  };
  onClickPaste = () => {
    const row = JSON.parse(localStorage.getItem("Row"));
    if (row) {
      const { values, content } = row;
      this.setState({
        type: values.width.type,
        contentWidth: values.width.contentWidth,
        backgroundColor: values.backgroundColor,
        containerPadding: values.padding,
        backgroundImage: values.backgroundImage,
        align: values.align,
        isBackgroundImage: values.isBackgroundImage,
        bgProps: values.bgProps,
        content: content
      });
    }
  };
  onClickSave = () => {
    let newData = this.props.data;
    let width = {
      type: this.state.type,
      contentWidth: this.state.contentWidth
    };
    newData.values.backgroundColor = this.state.backgroundColor;
    newData.values.padding = this.state.containerPadding;
    newData.values.align = this.state.align;
    newData.values.backgroundImage = this.state.backgroundImage;
    newData.values.isBackgroundImage = this.state.isBackgroundImage;
    newData.values.bgProps = this.state.bgProps;
    newData.values.width = width;
    newData.content = this.state.content;
    this.props.onUpdateData(newData);
  };

  onUpdatePadding = padding => {
    this.setState({ containerPadding: padding });
  };
  onSetValue = (key, value) => {
    this.setState({ contentWidth: value });
  };
  onChangeType = (event, value) => {
    let width = 0;
    let content = this.state.contentWidth;
    let interval = 20;
    if (value === "%") {
      width = 100;
      content = 100;
      interval = 1;
    }
    this.setState({
      type: value,
      maxValueWidth: width,
      contentWidth: content,
      interval: interval
    });
  };

  onChangeContentAlign = value => {
    this.setState({
      align: value
    });
  };

  updateBackground = values => {
    const {
      backgroundColor,
      backgroundImage,
      isBackgroundImage,
      bgProps
    } = values;
    this.setState({
      backgroundColor,
      backgroundImage,
      isBackgroundImage,
      bgProps
    });
  };
  updateBackgroundContent = (values, index) => {
    let { content } = this.state;
    // const {backgroundColor, backgroundImage, isBackgroundImage, bgProps} = values;
    content[index].props.values = assignIn(content[index].props.values, values);
    this.setState({
      content: content
    });
  };

  render() {
    const {
      backgroundColor,
      backgroundImage,
      isBackgroundImage,
      bgProps
    } = this.state;

    return (
      <div style={{ width: "100%" }}>
        <div style={{ overflowY: "scroll", height: 500 }}>
          <div style={styles.paperCard}>
            <Card
              expanded={this.state.expanded}
              onExpandChange={this.handleExpandChange}
            >
              <CardHeader
                title="Properties of Row"
                actAsExpander={true}
                showExpandableButton={true}
                style={styles.headerCard}
              />
              <CardText expandable={true}>
                <Paper style={styles.paperText} zDepth={1}>
                  <DivTitle>Container Padding</DivTitle>
                  <BlockCounter
                    containerPadding={this.state.containerPadding}
                    onUpdatePadding={containerPadding =>
                      this.onUpdatePadding(containerPadding)
                    }
                  />
                </Paper>
                <Paper style={styles.paperText} zDepth={1}>
                  <DivTitle>Container Width</DivTitle>
                  <RadioButtonGroup
                    name="type"
                    valueSelected={this.state.type}
                    onChange={this.onChangeType}
                    style={styles.radioGroup}
                  >
                    <RadioButton
                      value="%"
                      label="Percent"
                      style={styles.radioButton}
                    />
                    <RadioButton
                      value="px"
                      label="Pixel"
                      style={styles.radioButton}
                    />
                  </RadioButtonGroup>
                  <Counter
                    isDisabled={false}
                    onSetValue={value => this.onSetValue("Width", value)}
                    value={this.state.contentWidth}
                    interval={this.state.interval}
                    maxValue={this.state.maxValueWidth}
                  />
                </Paper>
                <BackgroundContent
                  backgroundColor={backgroundColor}
                  backgroundImage={backgroundImage}
                  isBackgroundImage={isBackgroundImage}
                  bgProps={bgProps}
                  updateBackground={this.updateBackground.bind(this)}
                />
              </CardText>
            </Card>
          </div>

          {this.state.content.map((item, index) => {
            const {
              backgroundColor,
              backgroundImage,
              isBackgroundImage,
              bgProps,
              width,
              alignment,
              padding,
              backgroundColorParent,
              typeBackground,
              backgroundCarousel
            } = item.props.values;
            const widthContent = width ? width : defaultItemProps.width;
            const alignContent = alignment
              ? alignment
              : defaultItemProps.alignment;
            const bgColorParent = backgroundColorParent
              ? backgroundColorParent
              : defaultItemProps.backgroundColorParent;

            const typeBackgroundContent = typeBackground
              ? typeBackground
              : defaultItemProps.typeBackground;
            const backgroundCarouselParent = backgroundCarousel
              ? backgroundCarousel
              : defaultItemProps.backgroundCarousel;
            return (
              <div style={styles.paperCard} key={index}>
                <Card
                  expanded={this.getExpand(index)}
                  onExpandChange={expanded =>
                    this.handleExpandChangeContentColumn(expanded, index)
                  }
                >
                  <CardHeader
                    title={`Properties of Content ${index + 1}`}
                    actAsExpander={true}
                    showExpandableButton={true}
                    style={styles.headerCard}
                  />
                  <CardText expandable={true}>
                    <ItemBackgroundContent
                      backgroundColorParent={bgColorParent}
                      padding={padding}
                      alignment={alignContent}
                      width={widthContent}
                      backgroundColor={backgroundColor}
                      backgroundImage={backgroundImage}
                      isBackgroundImage={isBackgroundImage}
                      bgProps={bgProps}
                      typeBackground={typeBackgroundContent}
                      backgroundCarousel={backgroundCarouselParent}
                      updateBackground={values =>
                        this.updateBackgroundContent(values, index)
                      }
                      title={`Content ${index + 1}`}
                    />
                  </CardText>
                </Card>
              </div>
            );
          })}
        </div>
        <DivHeaderActions>
          <IconButton
            onClick={this.onClickCopy}
            iconStyle={{ color: "#FFFFFF" }}
          >
            <ActionCopy />
          </IconButton>
          <IconButton
            onClick={this.onClickPaste}
            iconStyle={{ color: "#FFFFFF" }}
          >
            <ActionPaste />
          </IconButton>
          <IconButton
            onClick={this.onClickSave}
            iconStyle={{ color: "#FFFFFF" }}
          >
            <ActionSave />
          </IconButton>
        </DivHeaderActions>
      </div>
    );
  }
}

const styles = {
  paper: {
    margin: 10,
    padding: 10
  },
  headerCard: {
    display: "flex",
    textAlign: "left"
  },
  paperCard: {
    margin: 10
  },
  paperText: {
    padding: 10,
    marginBottom: 10
  },
  radioButton: {
    width: 100
  },
  radioGroup: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    flex: "1 auto",
    marginBottom: 10
  }
};

Row.propTypes = {
  data: PropTypes.object,
  onUpdateData: PropTypes.func.isRequired
};

Row.defaultProps = {
  data: {}
};
export default Row;



// WEBPACK FOOTER //
// ./src/editor/layout/addons/props/Row.js